import { render, staticRenderFns } from "./CountriesCharts.component.vue?vue&type=template&id=c51b84dc&scoped=true&"
import script from "./CountriesCharts.component.vue?vue&type=script&lang=js&"
export * from "./CountriesCharts.component.vue?vue&type=script&lang=js&"
import style0 from "./CountriesCharts.component.vue?vue&type=style&index=0&id=c51b84dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51b84dc",
  null
  
)

export default component.exports